export default __webpack_public_path__ + "static/media/video-1.6e4679cb.jpg";